export const getDashboardData = '/dashboard';
export const departedUser = '/dashboard/departed';
export const getFilteredInterns = '/dashboard/interns';
export const getFilteredCandidates = '/dashboard/candidates';
export const getTasksOverview = '/tasks/';
export const getTasksOverviewById = '/tasks/total/';
export const getMyProjectLeaders = '/tasks/intern-leaders/';
export const getProjectContribution = '/tasks/project-contribution/';
export const getTaskAssignment = '/tasks/user/task/assignment';
export const getRemainingTasks = '/tasks/remaining-tasks/';
